import { useTranslation } from "react-i18next"
import { useEffect, useMemo } from "react"
import { useQueryClient } from "react-query"

export default function useLanguage() {
  const { i18n } = useTranslation()
  const queryClient = useQueryClient()

  const language = useMemo(
    () => [...i18n.language].slice(0, 2).join(""),
    [i18n.language]
  )

  useEffect(() => {
    const onLanguageChanged = () => {
      document.body.classList.remove("lang-loading")
      queryClient.refetchQueries({ active: true })
    }
    const onFailed = () => {
      document.body.classList.remove("lang-loading")
    }

    i18n.on("languageChanged", onLanguageChanged)
    i18n.on("failedLoading", onFailed)

    return () => {
      i18n.off("languageChanged", onLanguageChanged)
      i18n.off("failedLoading", onFailed)
    }
  }, [i18n])

  const onChange = (lang: string) => {
    if (!lang) return
    window.location.reload()
    document.body.classList.add("lang-loading")
    i18n.changeLanguage(lang)
  }

  return { onChange, language }
}
